const nf = (number) => {
	return new Intl.NumberFormat('id-ID', {
		minimumFractionDigits: 0,
		roundingIncrement: 1,
	}).format(number);
};

export function nfComma(number) {
	const num = Number(number);
	if (isNaN(num)) return number;

	return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

/** Currency label aligned with preview (Rp45.000). */
export function nfRp(number) {
	const n = Number(number);
	if (Number.isNaN(n)) return 'Rp0';
	return `Rp${nf(n)}`;
}

export default nf;
